/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useRef } from "react";
import Header from "../../../Components/Dashboard/Header/Header";
import Sidebar from "../../../Components/Dashboard/Sidebar/Sidebar";
import { MdKeyboardArrowRight } from "react-icons/md";
import { BiHomeAlt } from "react-icons/bi";
import Select from "react-select";
import "./EMPDailyStatus.css";
import axios from "axios";
import { Apiurl, downloadFile, downloadMultipleFiles } from "../../../Utils/utils";
import { toast } from "react-toastify";
import EMPMonthlyReport from "./Empmonthlyreport";
import HomeTab from "../../AdminScreens/AdminDSR/HomeTab";

const HRDailyStatus = () => {
  const [showSidebar, setShowSidebar] = useState(true);
  const [activeTab, setActiveTab] = useState("dsr");
  const [editingId, setEditingId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    date: "",
    project: null,
    hours: "",
    minutes: "",
    task: "",
  });

  const [filterData, setFilterData] = useState({
    fromDate: "",
    toDate: "",
    project: null,
  });

  const [projects, setProjects] = useState([]);
  const [tasks, setTasks] = useState([]);

  // ── HomeTab state ──────────────────────────────────────────────
  const userDropdownRef = useRef(null);
  const FILE_PREFIX = "https://attendanceapi.elitewebdemo.com";

  const [homeSearchTerm, setHomeSearchTerm] = useState("");
  const [homeSelectFilter, setHomeSelectFilter] = useState("name");
  const [homeProjects, setHomeProjects] = useState([]);
  const [homeFilteredData, setHomeFilteredData] = useState([]);
  const [homeEmployees, setHomeEmployees] = useState([]);
  const [homeProjectTypes, setHomeProjectTypes] = useState([]);
  const [homeFormData, setHomeFormData] = useState({});
  const [homeShowModal, setHomeShowModal] = useState(false);
  const [homeModalType, setHomeModalType] = useState("");
  const [homeEditingItem, setHomeEditingItem] = useState(null);
  const [homeLoadingEditData, setHomeLoadingEditData] = useState(false);
  const [homeShowDeleteModal, setHomeShowDeleteModal] = useState(false);
  const [homeDeleteId, setHomeDeleteId] = useState(null);
  const [homeDeleteProjectName, setHomeDeleteProjectName] = useState("");
  const [homeShowNotesModal, setHomeShowNotesModal] = useState(false);
  const [homeNotesUrl, setHomeNotesUrl] = useState("");
  const [homeShowDocsModal, setHomeShowDocsModal] = useState(false);
  const [homeDocsList, setHomeDocsList] = useState([]);
  // ──────────────────────────────────────────────────────────────

  const getToken = () =>
    localStorage.getItem("token") || sessionStorage.getItem("token");

  const parseApiData = (data) => {
    if (!data) return [];
    let parsedData = data;
    if (typeof parsedData === "string") parsedData = JSON.parse(parsedData);
    if (parsedData?.Data) parsedData = parsedData.Data;
    if (parsedData?.data) parsedData = parsedData.data;
    return Array.isArray(parsedData) ? parsedData : [];
  };

  // ── HomeTab helpers ────────────────────────────────────────────
  const hasValidNotes = (notes) =>
    typeof notes === "string" && notes.trim() !== "";

  const getDocPath = (doc) => {
    if (!doc || typeof doc !== "object") return "";
    return doc.ProjectDoument || doc.File || doc.projectDoument || doc.file || "";
  };

  const getValidDocs = (docs) => {
    if (!Array.isArray(docs)) return [];
    return docs.filter((doc) => {
      const path = getDocPath(doc);
      return typeof path === "string" && path.trim() !== "";
    });
  };

  const hasValidDocs = (docs) => getValidDocs(docs).length > 0;

  const isQuillContentEmpty = (value) => {
    if (!value) return true;
    const plainText = value
      .replace(/<(.|\n)*?>/g, "")
      .replace(/&nbsp;/g, " ")
      .trim();
    return plainText === "";
  };

  const handleViewNotes = (notesFileUrl) => {
    const validNotes = hasValidNotes(notesFileUrl) ? notesFileUrl : "";
    setHomeNotesUrl(
      validNotes
        ? validNotes.startsWith("http")
          ? validNotes
          : FILE_PREFIX + validNotes
        : ""
    );
    setHomeShowNotesModal(true);
  };

  const handleDownloadNotes = (notesFileUrl) => {
    if (!hasValidNotes(notesFileUrl)) return;
    const fullUrl = notesFileUrl.startsWith("http")
      ? notesFileUrl
      : FILE_PREFIX + notesFileUrl;
    const fileName = fullUrl.split("/").pop();
    downloadFile(fullUrl, fileName);
  };

  const handleViewDocs = (docs) => {
    const validDocs = getValidDocs(docs);
    if (validDocs.length === 0) { toast.error("No documents available"); return; }
    const formattedDocs = validDocs.map((doc) => {
      const docPath = getDocPath(doc);
      const fullUrl = docPath.startsWith("http") ? docPath : FILE_PREFIX + docPath;
      return { url: fullUrl, fileName: docPath.split("\\").pop().split("/").pop() };
    });
    setHomeDocsList(formattedDocs);
    setHomeShowDocsModal(true);
  };

  const handleDownloadAllDocuments = (docsArr) => {
    const validDocs = getValidDocs(docsArr);
    if (validDocs.length === 0) { toast.error("No documents available"); return; }
    const files = validDocs.map((doc) => {
      const docPath = getDocPath(doc);
      const fullUrl = docPath.startsWith("http") ? docPath : FILE_PREFIX + docPath;
      return { url: fullUrl, fileName: docPath.split("\\").pop().split("/").pop() };
    });
    downloadMultipleFiles(files);
  };

  const handlePreviewSingleDoc = (url) => { if (url) window.open(url, "_blank"); };
  const handleDownloadSingleDoc = (url, fileName) => { if (url) downloadFile(url, fileName); };

  const fetchNotesHtmlContent = async (notesFileUrl) => {
    try {
      if (!notesFileUrl || typeof notesFileUrl !== "string") return "";
      const fullUrl = notesFileUrl.startsWith("http")
        ? notesFileUrl
        : FILE_PREFIX + notesFileUrl;
      const response = await axios.get(fullUrl, {
        headers: { authorization: `Bearer ${getToken()}` },
      });
      return response?.data || "";
    } catch (error) {
      console.error("Failed to load notes HTML:", error);
      return "";
    }
  };

  const fetchHomeProjects = () => {
    axios({
      method: "GET",
      headers: {
        "content-type": "application/json",
        authorization: `Bearer ${getToken()}`,
      },
      url: `${Apiurl()}/Projects/GetAllProjects`,
    })
      .then((response) => {
        if (response?.data?.success) {
          const parsed = JSON.parse(response.data.data || "{}");
          const projectsArray = parsed?.Data || [];
          const formatted = projectsArray.map((item) => {
            const assignedUsers = Array.isArray(item.AssignedUsers) ? item.AssignedUsers : [];
            const assignedUserIds = Array.isArray(item.AssignedUserIds)
              ? item.AssignedUserIds.map((id) => String(id))
              : [];
            const assignedUserNames = assignedUsers
              .map((user) => user.UserName || user.Email || "")
              .filter(Boolean);
            return {
              id: item.Project?.ProjectId,
              name: item.Project?.ProjectName || "",
              type: item.Project?.ProjectTypeNavigation?.ProjectType1 || "",
              projectTypeId: item.Project?.ProjectType || "",
              assignedUserIds,
              assignedUserNames,
              assignedUserName: assignedUserNames.join(", "),
              projectNotesFile: item.Project?.ProjectNotesFile || "",
              projectDocuments: Array.isArray(item.Documents)
                ? item.Documents
                : Array.isArray(item.ProjectDocuments)
                  ? item.ProjectDocuments
                  : [],
            };
          });
          setHomeProjects(formatted);
        } else {
          setHomeProjects([]);
        }
      })
      .catch(() => {
        toast.error("Failed to fetch projects");
        setHomeProjects([]);
      });
  };

  const fetchHomeEmployees = () => {
    axios({
      method: "GET",
      headers: {
        "content-type": "application/json",
        authorization: `Bearer ${getToken()}`,
      },
      url: `${Apiurl()}/Admin/GetAllEmployees`,
    })
      .then((response) => {
        if (response?.data?.success) {
          const firstParse = JSON.parse(response?.data?.data);
          const formatted = firstParse.map((item) => ({
            id: item.UserId,
            name: `${item.FirstName || ""} ${item.LastName || ""}`.trim(),
          }));
          setHomeEmployees(formatted);
        }
      })
      .catch(() => toast.error("Failed to fetch employees"));
  };

  const fetchHomeProjectTypes = () => {
    axios({
      method: "GET",
      headers: {
        "content-type": "application/json",
        authorization: `Bearer ${getToken()}`,
      },
      url: `${Apiurl()}/Projects/GetAllProjectTypes`,
    })
      .then((response) => {
        if (response?.data?.success) {
          const parsedData = JSON.parse(response?.data?.data);
          setHomeProjectTypes(parsedData);
        }
      })
      .catch(() => toast.error("Failed to fetch project types"));
  };

  const openHomeModal = async (type, item = null) => {
    setHomeModalType(type);
    setHomeEditingItem(item);

    if (type === "addProject" && item) {
      setHomeShowModal(true);
      setHomeLoadingEditData(true);
      const existingNotesFile = item.projectNotesFile || "";
      let existingHtmlContent = "";
      if (existingNotesFile) {
        existingHtmlContent = await fetchNotesHtmlContent(existingNotesFile);
      }
      setHomeFormData({
        Id: item.id,
        ProjectName: item.name,
        ProjectType: item.projectTypeId,
        AssignedUserIds: item.assignedUserIds || [],
        ExistingProjectNotesFile: existingNotesFile,
        ExistingProjectDocuments: item.projectDocuments || [],
        ProjectNoteHtmlContent: existingHtmlContent || "",
        ProjectDocumentsFiles: [],
        showUserDropdown: false,
      });
      setHomeLoadingEditData(false);
    } else {
      setHomeFormData({
        AssignedUserIds: [],
        ProjectName: "",
        ProjectType: "",
        ExistingProjectNotesFile: "",
        ExistingProjectDocuments: [],
        ProjectNoteHtmlContent: "",
        ProjectDocumentsFiles: [],
        showUserDropdown: false,
      });
      setHomeShowModal(true);
    }
  };

  const closeHomeModal = () => {
    setHomeShowModal(false);
    setHomeFormData({});
    setHomeEditingItem(null);
    setHomeLoadingEditData(false);
  };

  const handleHomeFormSubmit = () => {
    const hasProjectName = (homeFormData.ProjectName || "").trim() !== "";
    const hasProjectType = (homeFormData.ProjectType || "").toString().trim() !== "";
    const hasAssignedUser =
      Array.isArray(homeFormData.AssignedUserIds) && homeFormData.AssignedUserIds.length > 0;
    const hasNewNotes = !isQuillContentEmpty(homeFormData.ProjectNoteHtmlContent || "");
    const hasExistingNotes = hasValidNotes(homeFormData.ExistingProjectNotesFile);
    const hasNewDocs =
      Array.isArray(homeFormData.ProjectDocumentsFiles) &&
      homeFormData.ProjectDocumentsFiles.length > 0;
    const hasExistingDocs =
      Array.isArray(homeFormData.ExistingProjectDocuments) &&
      getValidDocs(homeFormData.ExistingProjectDocuments).length > 0;

    if (!hasProjectName) { toast.error("Project Name is required"); return; }
    if (!hasProjectType) { toast.error("Project Type is required"); return; }
    if (!hasAssignedUser) { toast.error("Assign User is required"); return; }
    if (!hasNewNotes && !hasExistingNotes) { toast.error("Project Notes is required"); return; }
    // if (!hasNewDocs && !hasExistingDocs) { toast.error("Project Document is required"); return; }

    const formDataPayload = new FormData();
    formDataPayload.append("ProjectId", homeEditingItem ? String(homeFormData.Id) : "0");
    formDataPayload.append("ProjectName", homeFormData.ProjectName);
    formDataPayload.append("ProjectType", homeFormData.ProjectType);
    (homeFormData.AssignedUserIds || []).forEach((id) => {
      formDataPayload.append("AssignedUserIds", id);
    });

    if (!isQuillContentEmpty(homeFormData.ProjectNoteHtmlContent || "")) {
      const blob = new Blob([homeFormData.ProjectNoteHtmlContent], { type: "text/html" });
      const htmlFile = new File(
        [blob],
        `${homeFormData.ProjectName || "project-notes"}.html`,
        { type: "text/html" }
      );
      formDataPayload.append("ProjectNoteHtmlFile", htmlFile);
    }

    if (hasNewDocs) {
      homeFormData.ProjectDocumentsFiles.forEach((file) => {
        formDataPayload.append("ProjectDocumentsFiles", file);
      });
    }

    axios({
      method: "POST",
      headers: { authorization: `Bearer ${getToken()}` },
      url: `${Apiurl()}/Projects/SaveProjectDsr`,
      data: formDataPayload,
    })
      .then((response) => {
        if (response?.data?.success) {
          toast.success("Project saved successfully");
          closeHomeModal();
          fetchHomeProjects();
        } else {
          toast.error(response?.data?.message || "Something went wrong");
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || "Error saving project");
      });
  };

  const handleHomeDeleteConfirm = () => {
    if (!homeDeleteId) return;
    axios({
      method: "POST",
      headers: {
        authorization: `Bearer ${getToken()}`,
        "content-type": "application/json",
      },
      url: `${Apiurl()}/Projects/DeleteProjectDSR?projectId=${homeDeleteId}`,
    })
      .then((response) => {
        if (response?.data?.success) {
          toast.success(response?.data?.message || "Project deleted successfully");
          fetchHomeProjects();
        } else {
          toast.error(response?.data?.message || "Failed to delete project");
        }
        setHomeShowDeleteModal(false);
        setHomeDeleteId(null);
        setHomeDeleteProjectName("");
        setHomeModalType("");
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || "Failed to delete project");
        setHomeShowDeleteModal(false);
        setHomeDeleteId(null);
        setHomeDeleteProjectName("");
        setHomeModalType("");
      });
  };

  const handleHomeDeleteCancel = () => {
    setHomeShowDeleteModal(false);
    setHomeDeleteId(null);
    setHomeDeleteProjectName("");
    setHomeModalType("");
  };

  const handleHomeUserCheckboxChange = (userId) => {
    const stringId = String(userId);
    const selectedIds = homeFormData.AssignedUserIds || [];
    const isSelected = selectedIds.includes(stringId);
    const updatedIds = isSelected
      ? selectedIds.filter((id) => id !== stringId)
      : [...selectedIds, stringId];
    setHomeFormData({ ...homeFormData, AssignedUserIds: updatedIds });
  };

  const getHomeSelectedUserNames = () => {
    if (!Array.isArray(homeFormData.AssignedUserIds) || homeFormData.AssignedUserIds.length === 0)
      return "Select Users";
    const selectedNames = homeEmployees
      .filter((emp) => homeFormData.AssignedUserIds.includes(String(emp.id)))
      .map((emp) => emp.name);
    if (selectedNames.length <= 2) return selectedNames.join(", ");
    return `${selectedNames[0]}, ${selectedNames[1]} + ${selectedNames.length - 2} more`;
  };

  const getHomeAllSelectedUserNames = () => {
    if (!Array.isArray(homeFormData.AssignedUserIds) || homeFormData.AssignedUserIds.length === 0)
      return "Select Users";
    return homeEmployees
      .filter((emp) => homeFormData.AssignedUserIds.includes(String(emp.id)))
      .map((emp) => emp.name)
      .join(", ");
  };

  // ── click outside dropdown ─────────────────────────────────────
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (userDropdownRef.current && !userDropdownRef.current.contains(event.target)) {
        setHomeFormData((prev) => ({ ...prev, showUserDropdown: false }));
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // ── HomeTab search filter ──────────────────────────────────────
  useEffect(() => {
    if (activeTab !== "projects") return;
    if (!homeSearchTerm.trim()) { setHomeFilteredData([]); return; }
    const filtered = homeProjects.filter((item) => {
      let value = "";
      if (homeSelectFilter === "name") value = item.name;
      else if (homeSelectFilter === "type") value = item.type;
      else if (homeSelectFilter === "assignedUser") value = item.assignedUserName;
      return value?.toLowerCase().includes(homeSearchTerm.toLowerCase());
    });
    setHomeFilteredData(filtered);
  }, [homeSearchTerm, homeSelectFilter, homeProjects, activeTab]);

  // ── DSR form helpers (unchanged) ──────────────────────────────
  const RetrieveProjects = () => {
    axios({
      method: "GET",
      headers: {
        "content-type": "application/json",
        authorization: `Bearer ${getToken()}`,
      },
      url: `${Apiurl()}/Projects/GetProjectsByUserId`,
    })
      .then((response) => {
        const apiData = response?.data?.Data || response?.data?.data;
        const projectsArray = parseApiData(apiData);
        const modifiedData = projectsArray.map((item) => ({
          value: item.ProjectId || item.projectId,
          label: item.ProjectName || item.projectName,
          projectType: item.ProjectType || item.projectType,
        }));
        setProjects(modifiedData);
      })
      .catch((error) => {
        console.log("Project API Error:", error);
        toast.error("Failed to load projects");
      });
  };

  const formatToBackendTime = (value, type) => {
    if (value === "" || value === null || value === undefined) return null;
    const num = Number(value);
    if (type === "hour") return `${String(num).padStart(2, "0")}:00:00`;
    if (type === "minute") return `00:${String(num).padStart(2, "0")}:00`;
    return null;
  };

  const formatFromBackendTime = (hourStr, minuteStr) => {
    const h = Number(hourStr?.split(":")[0] || 0);
    const m = Number(minuteStr?.split(":")[1] || 0);
    return `${h} hr ${m} min`;
  };

  const handleEditTask = (item) => {
    setFormData({
      date: item.Date?.split("T")[0] || "",
      project: {
        value: item.ProjectId,
        label: item.Project?.ProjectName || item.ProjectName,
      },
      hours: item.Hours?.split(":")[0] || "",
      minutes: item.Minutes?.split(":")[1] || "",
      task: item.TaskDetail || "",
    });
    setEditingId(item.Id);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleCancelEdit = () => {
    setFormData({ date: "", project: null, hours: "", minutes: "", task: "" });
    setEditingId(null);
  };

  const handleSaveTask = () => {
    if (
      !formData.date ||
      !formData.project ||
      !formData.task ||
      formData.hours === "" ||
      formData.minutes === ""
    ) {
      toast.error("Please fill all fields");
      return;
    }

    setLoading(true);
    const formattedHours = formatToBackendTime(formData.hours, "hour");
    const formattedMinutes = formatToBackendTime(formData.minutes, "minute");
    const safeTaskDetail = formData.task.replace(/'/g, '"');

    const payloadObject = editingId
      ? {
        Id: editingId,
        Date: formData.date,
        ProjectId: formData.project.value,
        Hours: formattedHours,
        Minutes: formattedMinutes,
        TaskDetail: safeTaskDetail,
      }
      : {
        Date: formData.date,
        ProjectId: formData.project.value,
        Hours: formattedHours,
        Minutes: formattedMinutes,
        TaskDetail: safeTaskDetail,
      };

    axios({
      method: "POST",
      headers: {
        authorization: `Bearer ${getToken()}`,
        "content-type": "application/json",
      },
      url: `${Apiurl()}/Task/SaveTaskDetail`,
      data: { data: JSON.stringify(payloadObject) },
    })
      .then(() => {
        toast.success(editingId ? "Task updated successfully" : "Task saved successfully");
        setFormData({ date: "", project: null, hours: "", minutes: "", task: "" });
        setEditingId(null);
        GetTasks();
      })
      .catch((error) => {
        console.log("Save Task Error:", error);
        toast.error(editingId ? "Failed to update task" : "Failed to save task");
      })
      .finally(() => setLoading(false));
  };

  const GetTasks = (overrideFilters = null) => {
    const filters = overrideFilters || filterData;
    const payloadObject = {
      fromDate: filters.fromDate || "",
      toDate: filters.toDate || "",
      dayscount: "",
    };

    axios({
      method: "POST",
      headers: {
        authorization: `Bearer ${getToken()}`,
        "content-type": "application/json",
      },
      url: `${Apiurl()}/Task/GetTasks`,
      data: { data: JSON.stringify(payloadObject) },
    })
      .then((res) => {
        const raw = JSON.parse(res?.data?.data || "{}");
        const parsed = raw?.Tasks || raw;
        let filtered = Array.isArray(parsed) ? parsed : [];
        if (filters.project) {
          filtered = filtered.filter(
            (t) => Number(t.ProjectId) === Number(filters.project.value)
          );
        }
        setTasks(filtered);
      })
      .catch((error) => {
        console.log("Get Tasks Error:", error);
        setTasks([]);
      });
  };

  const handleDeleteTask = (id) => {
    axios({
      method: "POST",
      headers: {
        authorization: `Bearer ${getToken()}`,
        "content-type": "application/json",
      },
      url: `${Apiurl()}/Task/DeleteTask`,
      data: { data: JSON.stringify({ Id: id }) },
    })
      .then(() => {
        toast.success("Task deleted successfully");
        setTasks((prev) => prev.filter((item) => item.Id !== id));
        setShowDeleteModal(false);
        setDeleteId(null);
        GetTasks();
      })
      .catch(() => {
        toast.error("Failed to delete task");
        setShowDeleteModal(false);
      });
  };

  const handleResetFilters = () => {
    const cleared = { fromDate: "", toDate: "", project: null };
    setFilterData(cleared);
    GetTasks(cleared);
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    if (tab !== "dsr") {
      setEditingId(null);
      setFormData({ date: "", project: null, hours: "", minutes: "", task: "" });
    }
    if (tab === "projects") {
      fetchHomeProjects();
      fetchHomeEmployees();
      fetchHomeProjectTypes();
    }
  };

  useEffect(() => {
    RetrieveProjects();
    GetTasks();
  }, []);

  useEffect(() => {
    if (window.innerWidth < 600) setShowSidebar(false);
  }, []);

  const isFormValid =
    formData.date &&
    formData.project &&
    formData.task &&
    formData.hours !== "" &&
    formData.minutes !== "";

  const homeDisplayData = homeSearchTerm ? homeFilteredData : homeProjects;

  return (
    <>
      <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />

      <div className="d-flex">
        <Sidebar showSidebar={showSidebar} />

        <section
          className={
            showSidebar ? "EMP-timesheet-section" : "EMP-timesheet-section-full"
          }
        >
          <div className="EMP-timesheet-header">
            <h2>Daily Status Report</h2>

            <div className="timesheet-breadcrumb">
              <BiHomeAlt />
              <MdKeyboardArrowRight />
              <span>Daily Status Report</span>
              <MdKeyboardArrowRight />
              <span>
                {activeTab === "dsr"
                  ? "Add Entry"
                  : activeTab === "report"
                    ? "Monthly Report"
                    : "Add Projects"}
              </span>
            </div>
          </div>

          {/* Tabs */}
          <div className="tabs-section-AdminDSR" style={{ marginBottom: "16px" }}>
            <button
              className={`tab-button ${activeTab === "dsr" ? "active" : ""}`}
              onClick={() => handleTabChange("dsr")}
            >
              Daily Status Report
            </button>
            <button
              className={`tab-button ${activeTab === "report" ? "active" : ""}`}
              onClick={() => handleTabChange("report")}
            >
              Monthly Report
            </button>
            <button
              className={`tab-button ${activeTab === "projects" ? "active" : ""}`}
              onClick={() => handleTabChange("projects")}
            >
              Add Projects
            </button>
          </div>

          {/* Tab: DSR Entry */}
          {activeTab === "dsr" && (
            <div className="timesheet-card">
              <div className="timesheet-note">
                <span>* Please fill all the fields before saving the task.</span>
              </div>

              <div className="timesheet-form-grid">
                <div className="form-group">
                  <label>Date</label>
                  <input
                    type="date"
                    value={formData.date}
                    max={new Date().toISOString().split("T")[0]}
                    onChange={(e) =>
                      setFormData({ ...formData, date: e.target.value })
                    }
                  />
                </div>

                <div className="form-group">
                  <label>Project</label>
                  <Select
                    options={projects}
                    value={formData.project}
                    onChange={(val) => setFormData({ ...formData, project: val })}
                    placeholder="Select Project"
                    isClearable
                  />
                </div>

                <div className="form-group">
                  <label>Hours</label>
                  <input
                    type="number"
                    placeholder="0"
                    min="0"
                    max="10"
                    value={formData.hours}
                    onChange={(e) => {
                      let value = e.target.value;
                      if (Number(value) > 10) {
                        toast.warning("Maximum allowed hours is 10");
                        value = 10;
                      }
                      setFormData({ ...formData, hours: value });
                    }}
                  />
                  <small className="input-hint">*Max 10 hours</small>
                </div>

                <div className="form-group">
                  <label>Minutes</label>
                  <input
                    type="number"
                    placeholder="00"
                    min="0"
                    max="59"
                    value={formData.minutes}
                    onChange={(e) => {
                      let value = e.target.value;
                      if (Number(value) > 59) {
                        toast.warning("Maximum allowed minutes is 59");
                        value = 59;
                      }
                      setFormData({ ...formData, minutes: value });
                    }}
                  />
                  <small className="input-hint">*Max 59 minutes</small>
                </div>

                <div className="form-group full">
                  <label>Task Detail</label>
                  <textarea
                    rows="4"
                    value={formData.task}
                    onChange={(e) =>
                      setFormData({ ...formData, task: e.target.value })
                    }
                  />
                </div>
              </div>

              <div className="timesheet-action-btns">
                <button
                  className="timesheet-save-btn"
                  onClick={handleSaveTask}
                  disabled={loading || !isFormValid}
                >
                  {loading ? "Saving..." : editingId ? "UPDATE" : "SAVE"}
                </button>

                {editingId && (
                  <button className="timesheet-cancel-btn" onClick={handleCancelEdit}>
                    CANCEL
                  </button>
                )}
              </div>

              <div className="timesheet-filters">
                <div className="filter-group">
                  <label>From Date</label>
                  <input
                    type="date"
                    value={filterData.fromDate}
                    max={new Date().toISOString().split("T")[0]}
                    onChange={(e) =>
                      setFilterData({ ...filterData, fromDate: e.target.value })
                    }
                  />
                </div>

                <div className="filter-group">
                  <label>To Date</label>
                  <input
                    type="date"
                    value={filterData.toDate}
                    max={new Date().toISOString().split("T")[0]}
                    min={filterData.fromDate || ""}
                    onChange={(e) =>
                      setFilterData({ ...filterData, toDate: e.target.value })
                    }
                  />
                </div>

                <div className="filter-group">
                  <label>Select Project</label>
                  <Select
                    options={projects}
                    value={filterData.project}
                    onChange={(val) =>
                      setFilterData({ ...filterData, project: val })
                    }
                    placeholder="Select Project"
                    isClearable
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      menu: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                  />
                </div>

                <button className="search-btn" onClick={() => GetTasks()}>
                  Search
                </button>

                <button className="reset-btn" onClick={handleResetFilters}>
                  Reset
                </button>
              </div>

              <div className="timesheet-table-wrapper">
                <table>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Date</th>
                      <th>Project Name</th>
                      <th>Task</th>
                      <th>Hour</th>
                      <th>Edit / Delete</th>
                    </tr>
                  </thead>

                  <tbody>
                    {tasks.length ? (
                      tasks.map((item, index) => (
                        <tr key={item.Id || index}>
                          <td>{index + 1}</td>
                          <td>{item.Date?.split("T")[0]}</td>
                          <td>
                            {item.Project?.ProjectName || item.ProjectName || "N/A"}
                          </td>
                          <td>{item.TaskDetail}</td>
                          <td>{formatFromBackendTime(item.Hours, item.Minutes)}</td>
                          <td>
                            <button
                              className="edit-btn"
                              onClick={() => handleEditTask(item)}
                            >
                              Edit
                            </button>

                            <button
                              className="delete-btn"
                              onClick={() => {
                                setDeleteId(item.Id);
                                setShowDeleteModal(true);
                              }}
                            >
                              Delete
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6">No data found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* Tab: Monthly Report */}
          {activeTab === "report" && <EMPMonthlyReport />}

          {/* Tab: Projects */}
          {activeTab === "projects" && (
            <HomeTab
              searchTerm={homeSearchTerm}
              setSearchTerm={setHomeSearchTerm}
              selectFilter={homeSelectFilter}
              setSelectFilter={setHomeSelectFilter}
              displayData={homeDisplayData}
              showNotesModal={homeShowNotesModal}
              setShowNotesModal={setHomeShowNotesModal}
              notesUrl={homeNotesUrl}
              handleViewNotes={handleViewNotes}
              handleDownloadNotes={handleDownloadNotes}
              showDocsModal={homeShowDocsModal}
              setShowDocsModal={setHomeShowDocsModal}
              docsList={homeDocsList}
              handleViewDocs={handleViewDocs}
              handleDownloadAllDocuments={handleDownloadAllDocuments}
              handlePreviewSingleDoc={handlePreviewSingleDoc}
              handleDownloadSingleDoc={handleDownloadSingleDoc}
              getValidDocs={getValidDocs}
              hasValidNotes={hasValidNotes}
              showModal={homeShowModal}
              modalType={homeModalType}
              closeModal={closeHomeModal}
              formData={homeFormData}
              setFormData={setHomeFormData}
              projectTypes={homeProjectTypes}
              employees={homeEmployees}
              loadingEditData={homeLoadingEditData}
              handleFormSubmit={handleHomeFormSubmit}
              handleUserCheckboxChange={handleHomeUserCheckboxChange}
              getSelectedUserNames={getHomeSelectedUserNames}
              getAllSelectedUserNames={getHomeAllSelectedUserNames}
              userDropdownRef={userDropdownRef}
              hasValidDocs={hasValidDocs}
              getDocPath={getDocPath}
              FILE_PREFIX={FILE_PREFIX}
              downloadFile={downloadFile}
              showDeleteModal={homeShowDeleteModal}
              setShowDeleteModal={setHomeShowDeleteModal}
              deleteId={homeDeleteId}
              setDeleteId={setHomeDeleteId}
              deleteProjectName={homeDeleteProjectName}
              setDeleteProjectName={setHomeDeleteProjectName}
              setModalType={setHomeModalType}
              handleDeleteConfirm={handleHomeDeleteConfirm}
              handleDeleteCancel={handleHomeDeleteCancel}
              openModal={openHomeModal}
            />
          )}

          {/* DSR Delete Confirmation Modal */}
          {showDeleteModal && (
            <div className="delete-modal-overlay">
              <div className="delete-modal">
                <h3>Confirm Delete</h3>
                <p>Are you sure you want to delete this task?</p>

                <div className="delete-modal-actions">
                  <button
                    className="confirm-delete-btn"
                    onClick={() => handleDeleteTask(deleteId)}
                  >
                    Yes
                  </button>

                  <button
                    className="cancel-delete-btn"
                    onClick={() => {
                      setShowDeleteModal(false);
                      setDeleteId(null);
                    }}
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          )}
        </section>
      </div>
    </>
  );
};

export default HRDailyStatus;